import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcherAuth() {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'de', label: 'Deutsch' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div className="language-switcher-auth">
      <button 
        className="language-toggle"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        {currentLanguage.label} <span className="dropdown-arrow">▼</span>
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {languages.map(language => (
            <button
              key={language.code}
              className={`language-option ${language.code === i18n.language ? 'active' : ''}`}
              onClick={() => changeLanguage(language.code)}
              type="button"
            >
              {language.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcherAuth;